import { render, staticRenderFns } from "./delete-shipment-confirmation.vue?vue&type=template&id=6ffc0a10&"
import script from "./delete-shipment-confirmation.vue?vue&type=script&lang=js&"
export * from "./delete-shipment-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports